module.exports = __webpack_public_path__ + "static/img/btn_bgc_1.27be163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/btn_bgc_1.png
// module id = m6bD
// module chunks = 98